import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

import { Box, BoxContent, BoxButtonWrapper, BoxButton } from './styles.InfoBox';

interface Props {
    isCollapsible?: boolean;
    buttonTextOpen?: string;
    buttonTextClose?: string;
    style?: React.CSSProperties;
    innerStyle?: React.CSSProperties;
}

export const InfoBox: React.FC<Props> = ({
    isCollapsible = false,
    buttonTextOpen = 'Weiterlesen',
    buttonTextClose = 'Schließen',
    style,
    innerStyle,
    children
}) => {
    const [isOpen, setIsOpen] = useState(!isCollapsible);

    return (
        <Box style={style} isOpen={isOpen} isCollapsible={isCollapsible}>
            <BoxContent style={innerStyle}>{children}</BoxContent>
            <BoxButtonWrapper>
                <BoxButton
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                >
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    {isOpen ? buttonTextClose : buttonTextOpen}
                </BoxButton>
            </BoxButtonWrapper>
        </Box>
    );
};
